<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-date-picker
          @input="onDateChange"
          v-model="date"
          :clearable="false"
          placeholder="Specify a date"
          class="datepicker--220"
        />
      </app-cells>
      <app-schedule :schedule="schedule" />
    </template>
  </div>
</template>

<script>
import { getClimbingBriefingSchedule } from '@/http'
import { format } from 'date-fns'
import AppSchedule from '@/components/AppSchedule.vue'

export default {
  name: 'BriefingSchedule',
  components: { AppSchedule },
  data() {
    return {
      is_loaded: false,
      schedule: null,
      date: format(new Date(), 'yyyy-MM-dd'),
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onDateChange() {
      this.fetchItems()
    },
    fetchItems() {
      getClimbingBriefingSchedule(this.date)
        .then(res => {
          this.schedule = res.data
          this.is_loaded = true
        })
    }
  }
}
</script>
